module.exports = __webpack_public_path__ + "img/date.7f963112.svg";